/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import { Row, Col, ToggleButton, Button, Form, Dropdown } from "react-bootstrap";

import { useAuth, useDispatcher } from "../../components/AuthProvider"

import { formatDisplayDate, formatShortDisplayDate } from '../../engine/date-helpers.js';
import { Icon } from "../../components/Icon";




// TODO make a common constant file or class
const ITEMTYPE_INCOME = 1;
const ITEMTYPE_EXPENSE = 2;
const ITEMTYPE_TRANSFER = 3;


function getUserSettings() {
  // These exist at root level, but no aure if we need to persist at that level,
  // will maintain the state here until we redo the UI
  let obj = {
    descFilter: '',
    showIncomes: true,
    showExpenses: true,
    showTransfers: true
  }

  return obj;
}


function Items(props) {
  const navigate = useNavigate();
  const results = useAuth();
  const dispatch = useDispatcher();
  const [descFilter, setDescFilter] = useState('');
  const [showIncomes, setShowIncomes] = useState(true);
  const [showExpenses, setShowExpenses] = useState(true);
  const [showTransfers, setShowTransfers] = useState(true);
  const [filters, setFilters] = useState(getUserSettings());

  let items = results.simResults.simModel.items;
  // let user_settings = props.results.userSettings; 


  function sortFunc(a, b) {
    if (a.active === false && b.active === true) {
      return 1;
    } else if (a.active === true && b.active === false) {
      return -1;
    }

    return a.fromSimAcct.baseDesc.localeCompare(b.fromSimAcct.baseDesc);
  }


  function filterFunc(item) {
    if (showIncomes === false && item.itemType === ITEMTYPE_INCOME)
      return false;

    if (showExpenses === false && item.itemType === ITEMTYPE_EXPENSE)
      return false;

    if (showTransfers === false && item.itemType === ITEMTYPE_TRANSFER)
      return false;

    if (descFilter.length > 0) {
      if (!item.baseDesc.toUpperCase().includes(descFilter.toUpperCase()))
        return false;
    }

    return true;
  }


  function nav(type) {
    navigate(`/app/planner/items/add/${type}`);
  }


  function onAddIncome(event) {
    event.preventDefault();
    nav('income');
  }


  function onAddExpense(event) {
    event.preventDefault();
    nav('expense');
  }


  function onAddTransfer(event) {
    event.preventDefault();
    nav('transfer');
  }


  function handleFilterChange(event) {
    event.preventDefault();

    setDescFilter(event.target.value);
  }


  function handleShowIncome(event) {
    event.preventDefault();

    setShowIncomes(!showIncomes);
  }


  function handleShowExpense(event) {
    event.preventDefault();

    setShowExpenses(!showExpenses);
  }


  function handleShowTransfer(event) {
    event.preventDefault(); showTransfers

    setShowTransfers(!showTransfers);
  }


  function handleEditItem(item) {
    let path = `/app/planner/items/${item.baseID}/edit`;
    navigate(path);
  }


  function handleDeleteItem(id) {
    let action = {
      type: 'deleteItem',
      id: id
    }

    dispatch(action);
  }


  function handleQuickControl(item) {
    let action = null;

    if (!item.hasQuickControl) {
      action = {
        type: 'addQuickControl',
        item: item,
      }
    } else {
      action = {
        type: 'deleteQuickControl',
        id: item.baseID,
      }

    }

    dispatch(action);
  }



  return (
    <React.Fragment>
      <Form>

        <Row>

          <Col xs={2}>
            <Form.Control type="text" value={descFilter} onChange={handleFilterChange} />

          </Col>
          <Col xs={3}>
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                Item Type
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <FilterButton enabled={showIncomes} desc="Incomes" onClick={handleShowIncome} />
                <FilterButton enabled={showExpenses} desc="Expenses" onClick={handleShowExpense} />
                <FilterButton enabled={showTransfers} desc="Transfers" onClick={handleShowTransfer} />
              </Dropdown.Menu>
            </Dropdown>

          </Col>
          <Col>
            <ToolbarButton title="Add Income" onClick={onAddIncome} />
            <ToolbarButton title="Add Expense" onClick={onAddExpense} />
            <ToolbarButton title="Add Transfer" onClick={onAddTransfer} />
          </Col>
        </Row>

      </Form>
      <Row>
        <Col>
          <ItemsList2 items={items.filter((item) => { return filterFunc(item) }).sort((a, b) => sortFunc(a, b))}
            onEdit={handleEditItem} onDelete={handleDeleteItem} handleQuickControl={handleQuickControl}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ItemsList items={items.filter((item) => { return filterFunc(item) }).sort((a, b) => sortFunc(a, b))}
            onEdit={handleEditItem} onDelete={handleDeleteItem} handleQuickControl={handleQuickControl}
          />
        </Col>
      </Row>

    </React.Fragment>
  );
}

//==================================================================================

function ItemsList(props) {

  return (
    <>
      {props.items.map((item, index) => <ItemSummary key={index} item={item} onEdit={props.onEdit} onDelete={props.onDelete} handleQuickControl={props.handleQuickControl} />)}
    </>
  );

}

//---------------------------------------------------------------------------------------

function ItemsList2(props) {

  let groups = groupItems(props.items);

  return (
    <>
      {groups.map( (g,i) => <Group key={i} group={g} onEdit={props.onEdit} onDelete={props.onDelete} handleQuickControl={props.handleQuickControl} /> )}
    </>
  );


  function groupItems(items) {
    let groups = [];

    let inactive = {
      acctId: -1,
      desc: "Inactive",

      items: []
    };

    for (let i = 0; i < items.length; i++) {
      let item = items[i];

      if (!item.active) {
        inactive.items.push(item);
      } else {
        let pos = groups.findIndex(g => g.acctId === item.srcActRef.baseID);
        if (pos === -1) {
          let group = {
            acctId: item.srcActRef.baseID,
            desc: item.srcActRef.baseDesc,

            items: []
          }

          pos = groups.length;
          groups.push(group);
        }

        groups[pos].items.push(item);
      }
    }

    groups.push(inactive);
    return groups;
  }
}


function Group(props) {
  const [isOpen, setIsOpen] = useState(false);

  function handleClick(event) {
    event.preventDefault();

    setIsOpen(!isOpen);
  }


  return (
    <Row>
      <Col><span onClick={handleClick}>{isOpen ? '-' : '+'}</span>{props.group.desc}</Col>
      {isOpen && props.group.items.map( (item,i) => <ItemSummary2 key={i} item={item} onEdit={props.onEdit} onDelete={props.onDelete} handleQuickControl={props.handleQuickControl} />)}
    </Row>
  )
}


//---------------------------------------------------------------------------------------

function FilterButton(props) {
  let color = props.enabled === true ? 'red' : 'green';

  let style = {
    color: color
  }

  return (
    <Dropdown.Item onClick={props.onClick}><span style={style}>{props.desc}</span></Dropdown.Item>
  );
}

//---------------------------------------------------------------------------------------

function ToolbarButton(props) {

  let color = props.isDev ? 'lightcoral' : 'lightblue';

  const style = {
    display: 'inline-block',
    margin: '5px',
    padding: '3px',
    //color: 
    background: color
  }


  return (
    <Button style={style} variant="primary" type="button" title={props.title} onClick={props.onClick} ><span>{props.title}</span></Button>
  );

}

//---------------------------------------------------------------------------------------

function ItemSummary(props) {

  const next_date = formatShortDisplayDate(props.item.nextDate);

  const editHandler = (event) => {
    event.preventDefault();

    props.onEdit(props.item);
  }

  const deleteHandler = (event) => {
    event.preventDefault();

    if (confirm("Are you sure !!")) {
      props.onDelete(props.item.baseID);
    }
  }

  const quickControlHandler = (event) => {
    event.preventDefault();

    props.handleQuickControl(props.item);
  }


  var amt_style = {
    textAlign: "right"
  }

  var inactive_style = {
    textDecoration: props.item.active === true ? "none" : "line-through"
  }


  // Item Amount is a string, convert and format
  const amount = parseFloat(props.item.amount).toFixed(2);


  return (
    <Row className="model-item-row">
      <Col xs={2}>{props.item.fromSimAcct.baseDesc}</Col>
      <Col xs={4} sm={2}><span style={inactive_style}>{props.item.baseDesc}</span></Col>
      <Col xs={1}>{next_date}</Col>
      <Col xs={1} style={amt_style}>{amount}</Col>

      <Col xs={4} sm={2}>
        <span><Icon.Edit onClick={editHandler} /></span>
        <span><Icon.Delete onClick={deleteHandler} /></span>
        <span><Icon.ToolSwitch enabled={props.item.hasQuickControl} onClick={quickControlHandler} /></span>
      </Col>
    </Row>
  )
}

//---------------------------------------------------------------------------------------

function ItemSummary2(props) {

  const next_date = formatShortDisplayDate(props.item.nextDate);

  const editHandler = (event) => {
    event.preventDefault();

    props.onEdit(props.item);
  }

  const deleteHandler = (event) => {
    event.preventDefault();

    if (confirm("Are you sure !!")) {
      props.onDelete(props.item.baseID);
    }
  }

  const quickControlHandler = (event) => {
    event.preventDefault();

    props.handleQuickControl(props.item);
  }


  var amt_style = {
    textAlign: "right"
  }

  var inactive_style = {
    textDecoration: props.item.active === true ? "none" : "line-through"
  }


  // Item Amount is a string, convert and format
  const amount = parseFloat(props.item.amount).toFixed(2);


  let child_style = {
    paddingLeft: "25px"
  }


  return (
    <Row className="model-item-row" style={child_style}>
      <Col xs={6} sm={2}><span style={inactive_style}>{props.item.baseDesc}</span></Col>
      <Col xs={2} sm={1}>{next_date}</Col>
      <Col xs={2} sm={1}style={amt_style}>{amount}</Col>

      <Col xs={2} sm={2}>
        <span><Icon.Edit onClick={editHandler} /></span>
        <span><Icon.Delete onClick={deleteHandler} /></span>
        <span><Icon.ToolSwitch enabled={props.item.hasQuickControl} onClick={quickControlHandler} /></span>
      </Col>
    </Row>
  )
}


export default Items;
